<div class="dashboardContainer">
  <div class="dashboardbgColor">
    <div class="tiles">
      <div class="wrapper">
        <div class="row">
          <div class="col-6">
            <kendo-card class="k-custom-card">
              <kendo-card-header class="k-custom-card-header">
                <div>
                  <h3 kendoCardTitle>Open Request</h3>
                  <!-- <p kendoCardSubtitle class="subtitle">Subheader</p> -->
                </div>
              </kendo-card-header>

              <kendo-card-body
                class="wrapper k-custom-card-body k-card-body k-columns-2"
                style="justify-content: space-evenly"
                >
                <div class="progress-status">
                  <div>
                    <p class="status-count">
                      {{ newEngagementRequestCount }}
                    </p>
                    <p>
                      New Engagement
                      {{
                      newEngagementRequestCount &&
                      newEngagementRequestCount > 0
                      ? "Requests"
                      : "Request"
                      }}
                    </p>
                  </div>
                  <div>
                    <p class="status-count">
                      {{ newUserRequestCount }}
                    </p>
                    <p>
                      New User
                      {{
                      newUserRequestCount && newUserRequestCount > 0
                      ? "Requests"
                      : "Request"
                      }}
                    </p>
                  </div>
                  <div>
                    <p class="status-count">
                      {{ newModuleRequestCount }}
                    </p>
                    <p>
                      Module
                      {{
                      newModuleRequestCount && newModuleRequestCount > 0
                      ? "Requests"
                      : "Request"
                      }}
                    </p>
                  </div>
                </div>
              </kendo-card-body>
            </kendo-card>
          </div>
          <div class="col-6 pl-0">
            <kendo-card class="k-custom-card">
              <kendo-card-header class="k-custom-card-header">
                <div>
                  <h3 kendoCardTitle>Progress</h3>
                  @if (loggedInUserRole === userRole.SupportUserRole) {
                    @if (
                      percentageCompletion) {
                      <p
                        kendoCardSubtitle
                        class="subtitle"
                        >
                        {{ percentageCompletion }}% (Requests Completed:
                        {{ completedRequestCount }}/{{ totalRequestCount }})
                      </p>
                    } @else {
                      <p style="margin: 0; line-height: 16px">Loading...</p>
                    }
                  }

                  @if (
                    loggedInUserRole === userRole.EngagementApproverUserRole
                    ) {
                    @if (percentageApproved) {
                      <p
                        kendoCardSubtitle
                        class="subtitle"
                        >
                        {{ percentageApproved }}% (Requests Approved:
                        {{ approvedRequestCount }}/{{
                        totalRequestCount + approvedRequestCount
                        }})
                      </p>
                    } @else {
                      <p style="margin: 0; line-height: 16px">Loading...</p>
                    }
                  }
                </div>
              </kendo-card-header>
              <kendo-card-body class="k-custom-card-body">
                <div style="place-self: center">
                  <kendo-arcgauge
                    [value]="
                      loggedInUserRole === userRole.SupportUserRole
                        ? percentageCompletion
                        : percentageApproved
                    "
                    [colors]="colors"
                    class="gauge"
                    style="margin-left: 0px"
                    >
                    <ng-template
                      kendoArcGaugeCenterTemplate
                      let-value="value"
                      let-color="color"
                      >
                      <h2 [style.color]="color">{{ value }}%</h2>
                    </ng-template>
                  </kendo-arcgauge>
                </div>
              </kendo-card-body>
            </kendo-card>
          </div>
        </div>
      </div>
    </div>

    <div class="grid-section">
      <div class="wrapper">
        <div class="grid-column">
          <div class="grid-shadow">
            <div class="divWrapper" style="justify-content: space-between">
              <div>
                <label style="color: rgb(24, 58, 181); margin-right: 10px"
                  >Requests</label
                  >
                  <kendo-textbox
                    [(value)]="searchValue"
                    [fillMode]="'outline'"
                    [style.width.px]="250"
                    placeholder="Search..."
                    (valueChange)="onFilter($event)"
                    style="background-color: whitesmoke !important"
                    >
                    <ng-template kendoTextBoxPrefixTemplate>
                      <kendo-svgicon [icon]="searchIcon"></kendo-svgicon>
                    </ng-template>
                  </kendo-textbox>
                </div>

                @if (loggedInUserRole === userRole.SupportUserRole) {
                  <div
                style="
                  display: flex;
                  align-items: center;
                  font-size: 12px;
                  gap: 10px;
                "
                    >
                    <kendo-label
                      class="k-display-block"
                      [for]="switch"
                      text="View Closed Request"
                    ></kendo-label>
                    <kendo-switch
                      size="small"
                      #switch
                      [(ngModel)]="switchChecked"
                      (valueChange)="selectViewClosedRequest()"
                    ></kendo-switch>
                  </div>
                }
              </div>
              <kendo-grid
              style="
                width: 100%;
                background-color: white;
                height: calc(100vh - 388px);
              "
                [kendoGridBinding]="requestList"
                kendoGridSelectBy="requestId"
                [selectable]="{ mode: 'multiple', drag: false }"
                [pageSize]="10"
                [pageable]="true"
                [sortable]="true"
                [groupable]="false"
                [reorderable]="false"
                [resizable]="false"
                [filterable]="false"
                [columnMenu]="false"
                [loading]="displayRequestsLoader"
                >
                <kendo-grid-column
                  field="createdDate"
                  title="Request Date"
                  [width]="110"
                  [class]="{ 'text-center': true }"
                  [resizable]="false"
                  [headerStyle]="{ color: '#757575' }"
                  [style]="{ color: '#757575' }"
                  >
                  <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.createdDate | date : "MM/dd/yyyy" }}
                  </ng-template>
                </kendo-grid-column>
                <kendo-grid-column
                  field="requestStatus"
                  title="Status"
                  [width]="80"
                  [class]="{ 'text-center': true }"
                  [resizable]="false"
                  [headerStyle]="{ color: '#757575' }"
                  [style]="{ color: '#757575' }"
                  >
                </kendo-grid-column>

                <kendo-grid-column
                  field="requestUserDisplayName"
                  title="Requested By"
                  [width]="120"
                  [class]="{ 'text-center': true }"
                  [resizable]="false"
                  [headerStyle]="{ color: '#757575' }"
                  [style]="{ color: '#757575' }"
                  >
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="ellipse"
                      kendoTooltip
                      filter="span"
                      >
                      <span class="ellipse" title="{{ dataItem.requestUserDisplayName }}">
                        {{ dataItem.requestUserDisplayName }}
                      </span>
                    </div>
                  </ng-template>
                </kendo-grid-column>

                <kendo-grid-column
                  field="requestType"
                  title="Menu Item"
                  [width]="110"
                  [class]="{ 'text-center': true }"
                  [resizable]="false"
                  [headerStyle]="{ color: '#757575' }"
                  [style]="{ color: '#757575' }"
                  >
                </kendo-grid-column>

                <kendo-grid-column
                  field="requestUserEmail"
                  title="Contact"
                  [width]="200"
                  [class]="{ 'text-center': true }"
                  [resizable]="false"
                  [headerStyle]="{ color: '#757575' }"
                  [style]="{ color: '#757575' }"
                  >
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="ellipse" kendoTooltip filter="a">
                      <kendo-svg-icon
                      style="
                        padding: 16px;
                        margin: 0px 0px 0px -15px;
                        color: #2196f3;
                        cursor: pointer;
                      "
                        [icon]="myspaceIcon"
                        (click)="openTeamsChat(dataItem.requestUserEmail)"
                        title="Open Teams Chat"
                      ></kendo-svg-icon>
                      <kendo-svg-icon
                      style="
                        padding: 2px;
                        margin-left: 0px;
                        margin-right: 6px;
                        color: #2196f3;
                        cursor: pointer;
                      "
                        [icon]="envelopIcon"
                        (click)="openEmail(dataItem.requestUserEmail)"
                        title="Send Email"
                      ></kendo-svg-icon>
                      <a class="ellipse"
                        style="color: #2196f3"
                        title="{{ dataItem.requestUserEmail }}"
                        >
                        {{ dataItem.requestUserEmail }}
                      </a>
                    </div>
                  </ng-template>
                </kendo-grid-column>

                <kendo-grid-column
                  field="clientName"
                  title="Client"
                  [width]="100"
                  [class]="{ 'text-center': true }"
                  [resizable]="false"
                  [headerStyle]="{ color: '#757575' }"
                  [style]="{ color: '#757575' }"
                  >
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="ellipse" kendoTooltip filter="span">
                      <span class="ellipse" title="{{ dataItem.clientName }}">
                        {{ dataItem.clientName }}
                      </span>
                    </div>
                  </ng-template>
                </kendo-grid-column>

                <kendo-grid-column
                  field="engagementName"
                  title="Engagement"
                  [width]="100"
                  [class]="{ 'text-center': true }"
                  [resizable]="false"
                  [headerStyle]="{ color: '#757575' }"
                  [style]="{ color: '#183AB5' }"
                  >
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="ellipse" kendoTooltip filter="span">
                      <span class="ellipse" title="{{ dataItem.engagementName }}">
                        {{ dataItem.engagementName }}
                      </span>
                    </div>
                  </ng-template>
                </kendo-grid-column>

                <kendo-grid-column
                  field="blank"
                  title=""
                  [width]="110"
                  [class]="{ 'text-center': true }"
                  [resizable]="false"
                  >
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <!-- <kendo-svg-icon [icon]="pencilIcon"  (click)="editUserRole(dataItem)" style="color: #005EB8;"></kendo-svg-icon> -->
                    <span
                      (click)="onEngagementRequestCellClick(dataItem)"
                      style="font-weight: 600; color: #212121; cursor: pointer"
                      >REVIEW REQUEST</span
                      >
                    </ng-template>
                  </kendo-grid-column>
                  <ng-template kendoGridNoRecordsTemplate>
                    @if (!displayRequestsLoader) {
                      <div>No records available</div>
                    }
                  </ng-template>
                  <ng-template kendoGridLoadingTemplate>
                    <ngx-spinner
                      bdColor="rgba(0, 0, 0, 0.1)"
                      size="default"
                      color="#225EFF"
                      type="ball-triangle-path"
                      [fullScreen]="false"
                      >
                    </ngx-spinner>
                  </ng-template>
                  <ng-template
                    kendoPagerTemplate
                    let-totalPages="totalPages"
                    let-currentPage="currentPage"
                    >
                    <div class="pager-container">
                      <div class="pager-content">
                        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                        <kendo-pager-numeric-buttons
                          [buttonCount]="pagerSettings.buttonCount"
                        ></kendo-pager-numeric-buttons>
                        <kendo-pager-next-buttons></kendo-pager-next-buttons>
                        <kendo-pager-info></kendo-pager-info>
                        <kendo-pager-page-sizes
                          [pageSizes]="pagerSettings.pageSizes"
                        ></kendo-pager-page-sizes>
                        <kendo-svgicon
                          [icon]="refresh"
                          class="right-align pointer"
                          (click)="getRequests()"
                          title="Refresh the Grid"
                        ></kendo-svgicon>
                      </div>
                    </div>
                  </ng-template>
                </kendo-grid>
              </div>
            </div>
          </div>
        </div>
        <span #anchor class="anchor"></span>
      </div>
    </div>

    <app-request-engagement-activity-panel
      [openRequestEngagementPopup]="isEngagementRequestPopupOpen"
      [engagementDetail]="selectedEngagementDetail"
      [selectedRequestId]="selectedRequestId"
      (closeEvent)="onEngagementRequestPopupClose()"
      [anchor]="anchor"
      [requestStatus]="requestStatus"
      [isApprovalUser]="isApprovalUser"
      >
    </app-request-engagement-activity-panel>

    <app-request-module-activity-panel
      [openRequestModulePopup]="isModuleRequestPopupOpen"
      [moduleRequestDetail]="selectedModuleDetail"
      [selectedRequestId]="selectedRequestId"
      (closeEvent)="onModuleRequestPopupClose()"
      [requestStatus]="requestStatus"
      [anchor]="anchor"
      [isApprovalUser]="isApprovalUser"
      >
    </app-request-module-activity-panel>

    <!-- Request Component -->
    <app-request-add-user-activity-panel
      [openUserAddPopup]="isUserAddPopupOpen"
      [userDetail]="userAddDetails"
      [selectedRequestId]="selectedRequestId"
      (closeEvent)="onUserAddPopupClose()"
      [requestStatus]="requestStatus"
      [anchor]="anchor"
      [isApprovalUser]="isApprovalUser"
      >
    </app-request-add-user-activity-panel>

    <app-request-remove-user-activity-panel
      [openUserRemovePopup]="isUserRemovePopupOpen"
      [removeUserData]="selectedRemovalUserData"
      [selectedRequestId]="selectedRequestId"
      (closeEvent)="closeRemoveUserPopup()"
      [requestStatus]="requestStatus"
      [anchor]="anchor"
      [isApprovalUser]="isApprovalUser"
      >
    </app-request-remove-user-activity-panel>
